module.exports = __webpack_public_path__ + "static/media/html-css-javascript-lg.04933e7f.jpg";